import Backbone from 'backbone';

export const CostCentreGroup = Backbone.Model.extend({
  defaults: {
    id: '',
    name: ''
  }
});


// WEBPACK FOOTER //
// ./receipt/models/costcentregroup.js